import PageBase from "./PageBase";
import React from "react";
import { authRequest } from "../../api/auth.js";
import Plot from "react-plotly.js";
import { host } from "../../config.js";
import {chart_color_font, chart_color_prices_decreasing, chart_color_prices_increasing,
    chart_color_mbuy, chart_color_msell, chart_color_volume,variant_table} from "../../settings.js";
import {Oval} from '@agney/react-loading'
import { Container, Row, Col, Button, ButtonGroup, Table } from 'react-bootstrap';
import {Helmet} from "react-helmet";

/**
 * @example
 * http://localhost:3000/weekly_price/?code=1301&date_from=2021-01-01&date_to=2022-01-01
 * http://localhost:3000/weekly_price/?code=1301&annot_date1=2021-12-20&annot_text1=Sample One
 * http://localhost:3000/weekly_price/?code=1301&annot_date1=2021-12-20&annot_text1=Sample One&annot_date2=2022-02-14&annot_text2=Sample Two
 * http://localhost:3000/weekly_price/?code=1301&annot_date1=2021-12-20&annot_text1=Sample One&annot_date2=2022-02-14&annot_text2=Sample Two&annot_date3=2022-03-28&annot_text3=Sample Three
 */
export default class WeeklyPrice extends PageBase {
    state = {
        prices_loading: true,
        companies_loading: true,
        prices_all: [],
        prices: [],
        count : 0,
        companies: [],
        duration: 0,
        offset: 0,
        annot_date1: null,
        annot_text1: null,
        annot_date2: null,
        annot_text2: null,
        annot_date3: null,
        annot_text3: null,
    }

    setPrices(queryParams){
       authRequest.get("http://"+host+":8000/api/weekly_prices",{ params: queryParams}) //WithAuth
            .then(res => {
                this.setState({ prices_all: res.data.results });
                this.setState({ prices: JSON.parse(JSON.stringify(this.state.prices_all)) });
                this.setState({ count: res.data.count });
                this.setState({ prices_loading: false });
        }).then(res => {this.setDuration(52)});
    }

    setCompanies(queryParams){
        let code = queryParams.get("code");
        authRequest.get("http://"+host+":8000/api/companies",{ params: { 'code': code } }) //WithAuth
            .then(res => {
                const companies = res.data.results;
                this.setState({ companies });
                this.setState({ companies_loading: false });
        })
    }

    /*
    setPrices(queryParams){
        let prices = [
            {id: 1, code: '1301' , open_date: '2021-08-30' , close_date: '2021-09-03', a_open:3010, a_high: 3055, a_low: 3005, a_close: 3045, a_volume: 54500, a_m_buy: 13700, a_m_sell: 10400},
            {id: 2, code: '1301' , open_date: '2021-09-06' , close_date: '2021-09-10', a_open:3045, a_high: 3095, a_low: 3035, a_close: 3095, a_volume: 71700, a_m_buy: 13800, a_m_sell: 10400},
            {id: 3, code: '1301' , open_date: '2021-09-13' , close_date: '2021-09-17', a_open:3090, a_high: 3135, a_low: 3075, a_close: 3130, a_volume: 72400, a_m_buy: 11100, a_m_sell: 10800},
            {id: 4, code: '1301' , open_date: '2021-09-21' , close_date: '2021-09-24', a_open:3100, a_high: 3100, a_low: 3005, a_close: 3065, a_volume: 49800, a_m_buy: 13300, a_m_sell: 10600},
            {id: 5, code: '1301' , open_date: '2021-09-27' , close_date: '2021-10-01', a_open:3065, a_high: 3095, a_low: 2986, a_close: 2995, a_volume: 73300, a_m_buy: 12800, a_m_sell: 8800},
            {id: 6, code: '1301' , open_date: '2021-10-04' , close_date: '2021-10-08', a_open:3010, a_high: 3035, a_low: 2951, a_close: 2998, a_volume: 81900, a_m_buy: 12100, a_m_sell: 8100},
            {id: 7, code: '1301' , open_date: '2021-10-11' , close_date: '2021-10-15', a_open:3025, a_high: 3050, a_low: 2985, a_close: 3050, a_volume: 47300, a_m_buy: 12300, a_m_sell: 4400},
            {id: 8, code: '1301' , open_date: '2021-10-18' , close_date: '2021-10-22', a_open:3045, a_high: 3075, a_low: 3005, a_close: 3010, a_volume: 38400, a_m_buy: 12400, a_m_sell: 4300},
            {id: 9, code: '1301' , open_date: '2021-10-25' , close_date: '2021-10-29', a_open:2995, a_high: 3055, a_low: 2980, a_close: 3050, a_volume: 119500, a_m_buy: 12000, a_m_sell: 4400},
            {id: 10, code: '1301' , open_date: '2021-11-01' , close_date: '2021-11-05', a_open:3085, a_high: 3250, a_low: 3055, a_close: 3110, a_volume: 119200, a_m_buy: 12300, a_m_sell: 4800},
            {id: 11, code: '1301' , open_date: '2021-11-08' , close_date: '2021-11-12', a_open:3075, a_high: 3120, a_low: 3025, a_close: 3110, a_volume: 45000, a_m_buy: 12100, a_m_sell: 4100},
            {id: 12, code: '1301' , open_date: '2021-11-15' , close_date: '2021-11-19', a_open:3100, a_high: 3130, a_low: 3030, a_close: 3040, a_volume: 44800, a_m_buy: 12800, a_m_sell: 3900},
            {id: 13, code: '1301' , open_date: '2021-11-22' , close_date: '2021-11-26', a_open:3030, a_high: 3060, a_low: 2990, a_close: 2995, a_volume: 35700, a_m_buy: 13400, a_m_sell: 4100},
            {id: 14, code: '1301' , open_date: '2021-11-29' , close_date: '2021-12-03', a_open:2975, a_high: 2997, a_low: 2900, a_close: 2982, a_volume: 72000, a_m_buy: 12700, a_m_sell: 4200},
            {id: 15, code: '1301' , open_date: '2021-12-06' , close_date: '2021-12-10', a_open:2982, a_high: 3105, a_low: 2965, a_close: 3105, a_volume: 66000, a_m_buy: 13400, a_m_sell: 4600},
            {id: 16, code: '1301' , open_date: '2021-12-13' , close_date: '2021-12-17', a_open:3110, a_high: 3140, a_low: 3055, a_close: 3095, a_volume: 62300, a_m_buy: 13100, a_m_sell: 4500},
            {id: 17, code: '1301' , open_date: '2021-12-20' , close_date: '2021-12-24', a_open:3095, a_high: 3095, a_low: 3020, a_close: 3025, a_volume: 40900, a_m_buy: 9500, a_m_sell: 3700},
            {id: 18, code: '1301' , open_date: '2021-12-27' , close_date: '2021-12-31', a_open:3040, a_high: 3105, a_low: 3030, a_close: 3080, a_volume: 33100, a_m_buy: 9500, a_m_sell: 3700},
            {id: 19, code: '1301' , open_date: '2022-01-04' , close_date: '2022-01-07', a_open:3110, a_high: 3115, a_low: 3070, a_close: 3070, a_volume: 36900, a_m_buy: 9300, a_m_sell: 3700},
        ];
        let count = prices.length;
        this.setState({ prices });
        this.setState({ count });
    }

    setCompanies(queryParams){
        let companies = [{"id": 1,"code": "1301","market": "t1","name": null,"name_ja": "(株)極洋","name_ja_ruby": null,
        "industry_id": 50,"industry": null,"industry_ja": "水産・農林業","fund_family": null,"fund_family_ja": null,
        "yld": null,"balance_sheet_month": null,"unit": null,"type": "stock_jp","description": null,
        "description_ja": "【特色】水産品の貿易、加工、買い付け主力。すしネタに強み。加工食品は業務用が軸。海外加工比率高い",
        "active": null}]
        this.setState({ companies });
    }
    */

    componentDidMount() {
        let queryParams = new URLSearchParams(window.location.search);
        this.setState({ annot_date1: queryParams.get('annot_date1') });
        this.setState({ annot_text1: queryParams.get('annot_text1') });
        this.setState({ annot_date2: queryParams.get('annot_date2') });
        this.setState({ annot_text2: queryParams.get('annot_text2') });
        this.setState({ annot_date3: queryParams.get('annot_date3') });
        this.setState({ annot_text3: queryParams.get('annot_text3') });
        queryParams.delete('annot_date1');
        queryParams.delete('annot_text1');
        queryParams.delete('annot_date2');
        queryParams.delete('annot_text2');
        queryParams.delete('annot_date3');
        queryParams.delete('annot_text3');
        this.setPrices(queryParams);
        this.setCompanies(queryParams);
    }

    getPos(value){
        if (value < 0){
            return 0;
        }
        return value;
    }

    setDuration(duration, offset_add=0){
        let prices = JSON.parse(JSON.stringify(this.state.prices_all));
        let offset = this.state.offset;
        let position = prices.length-duration+offset*duration/3;
        if(position + duration  + offset_add < prices.length){
            offset = offset + offset_add;
        }
        if(duration > 0){
            prices = prices.splice(position, duration);
        }
        this.setState(state => ({
            prices: prices,
            duration,
            offset
        }));
    }

    render() {

        const setDurationClick=(e)=>{
            let duration = parseInt(e.target.value);
            this.setDuration(duration);

        }

        const setOffsetClick=(e)=>{
            let offset_add = parseInt(e.target.value);
            this.setDuration(this.state.duration, offset_add);
        }

        const style_loading = {"height":"100vh"};
        const style = {
            "font-family": "Meiryo,Hiragino Sans,Hiragino Kaku Gothic ProN,Meiryo,sans-serif,Emoji;",
            "height":"100%"
        };
        let prices = this.state.prices;
        let companies = this.state.companies;
        let company = [];
        console.log('this.state.loading',this.state.loading);
        if (this.state.prices_loading && this.state.companies_loading){
            let r = (
            <Container style={style_loading}>
                <Helmet><title> Loading... </title></Helmet>
                <Row class="mt-5"><Col class="col-md-12">&nbsp;</Col></Row>
                <Row>
                    <Col class="col-md-4"></Col>
                    <Col class="col-md-4"><Oval width="250" color="#3db70f"/></Col>
                    <Col class="col-md-4"></Col>
                </Row>
                <Row class="mt-5"><Col class="col-md-12">&nbsp;</Col></Row>
            </Container>);
            return this.redirectLogin('/login', r);
        }else{
            companies.map((r) => (company = r))
            let _a_closes = [];
            prices.forEach(r => {_a_closes[r.open_date] = r.a_close});
            let annot1 = false;
            let annot2 = false;
            let annot3 = false;

            console.log('this.state.annot_date1', this.state.annot_date1);

            if (this.state.annot_date1 != null){
                annot1 = {
                                x: this.state.annot_date1,
                                y: _a_closes[this.state.annot_date1],
                                xref: 'x',
                                yref: 'y',
                                text: this.state.annot_text1,
                                showarrow: true,
                                arrowhead: 2,
                                ax: -20,
                                ay: 50
                              };
            }
            if (this.state.annot_date2 != null){
                annot2 = {
                                x: this.state.annot_date2,
                                y: _a_closes[this.state.annot_date2],
                                xref: 'x',
                                yref: 'y',
                                text: this.state.annot_text2,
                                showarrow: true,
                                arrowhead: 2,
                                ax: -20,
                                ay: 50
                              };
            }
            if (this.state.annot_date3 != null){
                annot3 = {
                                x: this.state.annot_date3,
                                y: _a_closes[this.state.annot_date3],
                                xref: 'x',
                                yref: 'y',
                                text: this.state.annot_text3,
                                showarrow: true,
                                arrowhead: 2,
                                ax: -20,
                                ay: 50
                              };
            }
            let r = (
                <Container style={style}>
                    <Helmet><title> {company.code} {company.name_ja}</title></Helmet>
                    <div class="row pt-3">
                        <div class="col-md-1"></div>
                        <div class="col-md-10 bg-secondary text-center">
                            <h6 class="text-light">{companies.map((r) => (r.code+'  '+ r.industry_ja))}</h6>
                            <h2 class="text-light">{companies.map((r) => (r.name_ja))}</h2>
                    <ButtonGroup>
                    <Button variant="secondary" onClick={setOffsetClick} value='-1'> ⬅  </Button>
                    <Button variant="secondary" onClick={setDurationClick} value='-1'> Max </Button>
                    <Button variant="secondary" onClick={setDurationClick} value='932'> 16 Years </Button>
                    <Button variant="secondary" onClick={setDurationClick} value='416'> 8 Years </Button>
                    <Button variant="secondary" onClick={setDurationClick} value='208'> 4 Years </Button>
                    <Button variant="secondary" onClick={setDurationClick} value='104' > 2 Years </Button>
                    <Button variant="secondary" onClick={setDurationClick} value='52'> 1 Year </Button>
                    <Button variant="secondary" onClick={setDurationClick} value='26'> 6 months </Button>
                    <Button variant="secondary" onClick={setDurationClick} value='13'> 3 months </Button>
                    <Button variant="secondary" onClick={setOffsetClick} value='1'> ➡  </Button>
                    </ButtonGroup>
                        </div>
                        <div class="col-md-1">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-11" id="div_plot" >
                            <Plot
                                data={[
                                    {
                                        name: "Price",
                                        x: prices.map((r) => r.open_date),
                                        high: prices.map((r) => r.a_high),
                                        low: prices.map((r) => r.a_low),
                                        open: prices.map((r) => r.a_open),
                                        close: prices.map((r) => r.a_close),
                                        decreasing: { line: {color: chart_color_prices_decreasing }},
                                        increasing: { line: {color: chart_color_prices_increasing }},
                                        line: { color: "rgba(31,119,180,1)", width: 3 },
                                        type: "candlestick",
                                        xaxis: "x1",
                                        yaxis: "y1",
                                    },
                                    {
                                        name: "Volume",
                                        x: prices.map((r) => r.open_date),
                                        y: prices.map((r) => r.a_volume),
                                        type: "bar",
                                        //shared_xaxes: true,
                                        //secondary_y: true,
                                        marker: {
                                          color: chart_color_volume,
                                          opacity: 0.6,
                                          line: {
                                            color: "rgb(8,48,107)",
                                            width: 0.1,
                                          },
                                        },
                                        xaxis: "x1",
                                        yaxis: "y2",
                                    },
                                    {
                                        name: "M.Buy",
                                        x: prices.map((r) => r.open_date),
                                        y: prices.map((r) => r.a_m_buy),
                                        type: "line",
                                        secondary_y: true,
                                        shared_xaxes: true,
                                        marker: {
                                          color: chart_color_mbuy,
                                          opacity: 0.6,
                                          line: {
                                            color: chart_color_msell,
                                            width: 0.1,
                                          },
                                        },
                                        xaxis: "x2",
                                        yaxis: "y3",
                                    },
                                    {
                                        name: "M.Sell",
                                        x: prices.map((r) => r.open_date),
                                        y: prices.map((r) => r.a_m_sell),
                                        type: "line",
                                        secondary_y: true,
                                        shared_xaxes: true,
                                        marker: {
                                          color: "red",
                                          opacity: 0.6,
                                          line: {
                                            color: "rgb(8,48,107)",
                                            width: 0.1,
                                          },
                                        },
                                        xaxis: "x2",
                                        yaxis: "y3",
                                    },
                                    {
                                        name: "DC Ratio",
                                        x: prices.map((r) => r.open_date),
                                        y: prices.map((r) => r.dc_ratio),
                                        type: "line",
                                        secondary_y: true,
                                        shared_xaxes: true,
                                        marker: {
                                          color: "purple",
                                          opacity: 0.6,
                                          line: {
                                            color: "rgb(8,48,107)",
                                            width: 0.1,
                                          },
                                        },
                                        xaxis: "x2",
                                        yaxis: "y4",
                                    },
                                    {
                                        name: "M.Buy",
                                        x: prices.map((r) => r.open_date),
                                        y: prices.map((r) => r.a_m_buy),
                                        type: "line",
                                        secondary_y: true,
                                        shared_xaxes: true,
                                        marker: {
                                          color: chart_color_mbuy,
                                          opacity: 0.6,
                                          line: {
                                            color: chart_color_msell,
                                            width: 0.1,
                                          },
                                        },
                                        xaxis: "x5",
                                        yaxis: "y5",
                                    },
                                    {
                                        name: "M.Sell",
                                        x: prices.map((r) => r.open_date),
                                        y: prices.map((r) => r.a_m_sell),
                                        type: "line",
                                        secondary_y: true,
                                        shared_xaxes: true,
                                        marker: {
                                          color: "red",
                                          opacity: 0.6,
                                          line: {
                                            color: "rgb(8,48,107)",
                                            width: 0.1,
                                          },
                                        },
                                        xaxis: "x6",
                                        yaxis: "y6",
                                    },
                                ]}
                                layout={{
                                  title: company.code,
                                  width: window.innerWidth*8/10,
                                  height: window.innerWidth*8/10,
                                  showlegend: false,
                                  annotations: [annot1, annot2, annot3],
                                  paper_bgcolor: "rgba(0,0,0,0)", //transparent background
                                  plot_bgcolor: "rgba(0,0,0,0)", //transparent background
                                  font: {
                                      //family: 'Courier New, monospace',
                                      //size: 18,
                                      color: chart_color_font
                                  },
                                  xaxis: {
                                    fixedrange: true,
                                    rangeslider: {
                                      visible: false,
                                    },
                                    //tickformat: '%Y-%m',
                                  },
                                  yaxis1: {
                                    title: "Price",
                                    fixedrange: true,
                                    showgrid: false,
                                    domain: [0.6, 1],//[0.33, 1],
                                  },
                                  yaxis2: {
                                    title: "Volume",
                                    showgrid: false,
                                    side: "right",
                                    domain: [0.4, 0.58],//domain: [0, 0.3],
                                  },
                                  yaxis3: {
                                    title: "Margin",
                                    side: "left",
                                    showgrid: false,
                                    overlaying: "y2",
                                  },
                                  yaxis4: {
                                    //title: "DC Ratio",
                                    side: "left",
                                    showgrid: false,
                                    overlaying: "y2",
                                  },
                                  yaxis5: {
                                    title: "M. Buying",
                                    side: "left",
                                    showgrid: true,
                                    domain: [0.2, 0.37],
                                  },
                                  yaxis6: {
                                    title: "M. Selling",
                                    side: "left",
                                    showgrid: true,
                                    domain: [0, 0.17],
                                  },
                                  grid: {
                                    rows: 2,
                                    columns: 1,
                                    //subplots: [["xy1"], ["xy3"]],
                                    roworder: "top to bottom",
                                  },
                                }}
                            />
                        </div>
                        <div class="col-md-1"></div>
                    </div>
                    <div>
                        <Table striped bordered hover variant={variant_table}>
                                {companies.map((r) => (
                              <tr>
                                <td key={r.id}>{r.code}</td>
                                <td>{r.market}</td>
                                <td>{r.name_ja}</td>
                                <td>{r.industry_ja}</td>
                                <td>{r.description_ja}</td>
                              </tr>
                            ))
                            }
                        </Table>
                    </div>
                    <div>
                        Count : {prices.length}
                    </div>
                    <div>
                        <Table striped bordered hover variant={variant_table}>
                            <thead>
                              <tr>
                                <th scope="col">Code</th>
                                <th scope="col">Date (Open)</th>
                                <th scope="col">Date (Close)</th>
                                <th scope="col">Open</th>
                                <th scope="col">High</th>
                                <th scope="col">Low</th>
                                <th scope="col">Close</th>
                                <th scope="col">Volume</th>
                                <th scope="col">M. Buy</th>
                                <th scope="col">M. Sell</th>
                              </tr>
                            </thead>
                            <tbody>
                              {prices.map((r) => (
                                  <tr>
                                    <td key={r.id}>{r.code}</td>
                                    <td>{r.open_date}</td>
                                    <td>{r.close_date}</td>
                                    <td>{r.a_open}</td>
                                    <td>{r.a_high}</td>
                                    <td>{r.a_low}</td>
                                    <td>{r.a_close}</td>
                                    <td>{r.a_volume}</td>
                                    <td>{r.a_m_buy}</td>
                                    <td>{r.a_m_sell}</td>
                                  </tr>
                                ))
                                .reverse()}
                            </tbody>
                        </Table>
                    </div>
                </Container>
            );
            return this.redirectLogin('/login', r);
        }
    }
}
